import { Color } from '../../../../../../enums/color'
import { Divider } from '../../../../../Divider'
import { Space } from '../../../../../Space'

export const ElementsDivider = () => (
  <>
    <Space size="s8" horizontal />
    <Divider direction="vertical" dividerColor={Color.Grey200} />
    <Space size="s8" horizontal />
  </>
)
